import { arrayOf, bool, func, shape, string } from "prop-types";
import * as StyleguideMetrics from "./styleguide/metrics.vars";

import StyleguidePalette from "./styleguide/palette.vars";

const CustomMetrics = {
  Timing: {
    OVERLAY_ACCORDION: 350
  },
  FontSizes: {
    NAVBAR_ITEM_ICON: 16,
    NAVBAR_ITEM_ICON_SMALL: 14,
    NAVBAR_ITEM_TEXT: 14,

    TOOLBAR_ITEM_ICON: 18,

    OVERLAY_MENU_TOGGLE_TEXT: 16,
    OVERLAY_MENU_ITEM_TEXT: 14,

    OVERLAY_TOOLBAR_BUTTON_TEXT: 16,
    OVERLAY_TOOLBAR_BUTTON_ICON: 16,
    OVERLAY_HEADING: 24
  },
  LineHeights: {
    NAVBAR_ITEM_TEXT: 32,
    NAVBAR_DROPDOWN_MENU_ITEM_TEXT: 24,

    MOBILE_TOOLBAR_BUTTON: 16,

    TOOLBAR_ITEM_TEXT: 24,

    OVERLAY_HEADING: 24,
    OVERLAY_TOOLBAR_BUTTON_TEXT: 22
  },
  Heights: {
    NAVBAR_ITEM_DIVIDER: 30,

    NAVBAR_DROPDOWN_MENU_ARROW: 7
  },
  Margins: {
    TOOLBAR_ITEM_ICON_RIGHT: 13,
    NAVBAR_ITEM_LABEL_X: 15,
    OVERLAY_TOOLBAR_BUTTON_ICON_SECONDARY_LEFT: 8
  },
  Padding: {
    NAVBAR_ITEM_X: 20,
    NAVBAR_ITEM_Y: 26,
    NAVBAR_DROPDOWN_MENU_Y: 32,

    // Origin Logo offset, don't need for LG screens
    NAVBAR_LEFT_MD: 98,
    NAVBAR_LEFT_LG: 0,

    TOOLBAR_ITEM_X: 15,
    TOOLBAR_ITEM_Y: 12,

    MOBILE_TOOLBAR_TOGGLE_X: 22,
    MOBILE_TOOLBAR_BUTTON_X: 24,

    OVERLAY_TOOLBAR_BUTTON_Y: 22,

    OVERLAY_HEADING_TOP: 36,
    OVERLAY_HEADING_BOTTOM: 28,

    OVERLAY_MENU_TOGGLE_Y: 24,
    OVERLAY_MENU_TOGGLE_RIGHT: 24,

    OVERLAY_MENU_ITEM_X: 52
  },
  Widths: {
    NAVBAR_ITEM_DIVIDER: 1,
    TOOLBAR_ITEM_DIVIDER: 1,

    NAVBAR_ITEM_UNDERLINE: 3,
    NAVBAR_DROPDOWN_MENU: 324,
    NAVBAR_DROPDOWN_MENU_ITEM_UNDERLINE: 3,
    NAVBAR_DROPDOWN_MENU_ARROW: 11
  }
};

export const Metrics = {
  FontSizes: {
    ...CustomMetrics.FontSizes,
    NAVBAR_DROPDOWN_MENU_ITEM_TEXT: StyleguideMetrics.FontSizes.COPY,

    TOOLBAR_ITEM_TEXT: StyleguideMetrics.FontSizes.SUBTEXT
  },
  LineHeights: {
    ...CustomMetrics.LineHeights
  },
  Padding: {
    ...CustomMetrics.Padding,

    NAVBAR_ITEM_X_LG: StyleguideMetrics.Spacing.P_X_LG,
    NAVBAR_DROPDOWN_MENU_X: StyleguideMetrics.Spacing.P_X_LG,
    NAVBAR_DROPDOWN_MENU_ITEM_Y: StyleguideMetrics.Spacing.P_Y_XS,

    OVERLAY_TOOLBAR_BUTTON_X: StyleguideMetrics.Spacing.P_X,

    OVERLAY_MENU_TOGGLE_LEFT: StyleguideMetrics.Spacing.P_X,

    OVERLAY_MENU_Y: StyleguideMetrics.Spacing.P_Y_SM,
    OVERLAY_MENU_ITEM_Y: StyleguideMetrics.Spacing.P_Y_SM
  },
  Margins: {
    ...CustomMetrics.Margins
  },
  Heights: {
    ...CustomMetrics.Heights,
    TOOLBAR:
      StyleguideMetrics.LineHeights.SUBTEXT +
      CustomMetrics.Padding.TOOLBAR_ITEM_Y * 2,

    OVERLAY_TOOLBAR:
      CustomMetrics.LineHeights.OVERLAY_TOOLBAR_BUTTON_TEXT +
      CustomMetrics.Padding.OVERLAY_TOOLBAR_BUTTON_Y * 2
  },
  Timing: {
    ...CustomMetrics.Timing
  },
  Widths: {
    ...CustomMetrics.Widths
  },
  ZIndexes: {
    NAVBAR_DROPDOWN_MENU_ARROW:
      StyleguideMetrics.ZIndexes.HOVER_DROPDOWN_MENU + 1,
    HOVER_DROPDOWN_MENU: StyleguideMetrics.ZIndexes.HOVER_DROPDOWN_MENU
  }
};

export const Palette = {
  Rebrand: {
    Colours: {
      P1: "#ff373c",
      P2: "#ec0000",
      P3: "#ff8228",
      P4: "#ffb432",
      P5: "#d2f0ff",
      P6: "#505050",
      S1: "#3f75c6",
      S2: "#008906",
      S3: "#c34789",
      S4: "#a5bb48",
      G1: "#f8f8f8",
      G2: "#f1f1f1",
      G3: "#e3e3e3",
      G4: "#ababab",
      G5: "#737373",
      G6: "#232323",
      W1: "#fff"
    }
  },
  // Desktop
  NAVBAR_BG: StyleguidePalette.WHITE,
  NAVBAR_BORDER: StyleguidePalette.GREY_MEDIUM,

  NAVBAR_ITEM_TEXT: "#666666",
  NAVBAR_ITEM_DIVIDER: StyleguidePalette.GREY_MEDIUM,
  NAVBAR_ITEM_UNDERLINE: StyleguidePalette.ORANGE_DARK,
  NAVBAR_ITEM_ICON_BORDER: StyleguidePalette.GREY,

  NAVBAR_ITEM_CHEVRON: StyleguidePalette.ORANGE_DARK,
  NAVBAR_DROPDOWN_MENU_BORDER: StyleguidePalette.GREY,
  NAVBAR_DROPDOWN_MENU_BG: StyleguidePalette.WHITE,
  NAVBAR_DROPDOWN_MENU_ITEM_TEXT: StyleguidePalette.CHARCOAL_BODY,
  NAVBAR_DROPDOWN_MENU_ITEM_TEXT_HOVER: StyleguidePalette.CHARCOAL_HOVER,
  NAVBAR_DROPDOWN_MENU_ITEM_TEXT_UNDERLINE: StyleguidePalette.ORANGE_DARK,
  NAVBAR_DROPDOWN_MENU_BUTTON_BORDER: StyleguidePalette.GREY_LIGHT,

  TOOLBAR_BG: StyleguidePalette.CHARCOAL,
  TOOLBAR_ITEM_DIVIDER: "#E3E3E3",
  TOOLBAR_ITEM_TEXT: "#CCCCCC",
  TOOLBAR_ITEM_TEXT_HOVER: StyleguidePalette.WHITE,

  // Mobile
  MOBILE_TOOLBAR_ITEM: "#CCCCCC",
  MOBILE_TOOLBAR_TOGGLE: StyleguidePalette.WHITE,

  OVERLAY_BG: StyleguidePalette.CHARCOAL,

  OVERLAY_TOOLBAR_BG: "#fff",
  OVERLAY_TOOLBAR_BUTTON_TEXT: StyleguidePalette.WHITE,
  OVERLAY_TOOLBAR_BUTTON_ICON: StyleguidePalette.WHITE,
  OVERLAY_TOOLBAR_BUTTON_ICON_SECONDARY: "#969696",
  OVERLAY_CLOSE_ICON: StyleguidePalette.ORANGE_DARK,

  OVERLAY_COLLAPSIBLE_BG: StyleguidePalette.WHITE,
  OVERLAY_COLLAPSIBLE_LABEL_TEXT: "#666666",

  OVERLAY_DIVIDER: StyleguidePalette.GREY,
  OVERLAY_HEADING_BG: StyleguidePalette.WHITE,
  OVERLAY_HEADING_TEXT: StyleguidePalette.ORANGE_DARK,
  OVERLAY_FOOTER_TEXT: StyleguidePalette.ORANGE_DARK,

  OVERLAY_MENU_BG: StyleguidePalette.GREY_LIGHT,
  OVERLAY_MENU_ITEM_TEXT: "#666666",
  OVERLAY_MENU_ITEM_TEXT_HOVER: StyleguidePalette.CHARCOAL_BODY
};

export const NavItemPropTypes = {
  label: shape({
    text: string.isRequired,
    icon: string.isRequired,
    smallIcon: bool
  }),
  menuItems: arrayOf(
    shape({
      desktopOnly: bool,
      label: string.isRequired,
      href: string,
      icon: string,
      onClick: func
    })
  )
};

export const NavStructurePropTypes = {
  navStructure: arrayOf(shape({ ...NavItemPropTypes })).isRequired
};

export const ToolbarItemPropTypes = {
  text: string,
  icon: string,
  href: string
};

export const ToolbarItemsPropTypes = {
  toolbarItems: arrayOf(shape({ ...ToolbarItemPropTypes })).isRequired
};

export const cookieNames = {
  IS_LOGGED_IN: "is-logged-in"
};
